import { Box, BoxProps } from "@mui/material";

type Props = {
  color: string;
  size?: number;
  sx?: BoxProps["sx"];
};

const OCTAGON_CLIP_PATH = "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)";

const PrecautionOctagon = ({ color, size = 16, sx }: Props) => (
  <Box
    sx={{
      width: size,
      height: size,
      clipPath: OCTAGON_CLIP_PATH,
      backgroundColor: color,
      flexShrink: 0,
      ...sx,
    }}
  />
);

export default PrecautionOctagon;
